// combinedWithdrawSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchWithdrawRequests,
  withdrawRequest,
} from "../../utilities/services/withdraw";

// Async thunk to fetch withdraw requests
export const getWithdrawRequests = createAsyncThunk(
  "withdraw/getWithdrawRequests",
  async (userId) => {
    const response = await fetchWithdrawRequests(userId);
    return response.data.data;
  }
);

// Async thunk to send withdraw request
export const sendWithdrawRequest = createAsyncThunk(
  "withdraw/sendRequest",
  async (data, { rejectWithValue }) => {
    try {
      const response = await withdrawRequest(data);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const withdrawSlice = createSlice({
  name: "withdraw",
  initialState: {
    withdrawRequests: [],
    loadingRequests: false,
    loadingSend: false,
    success: null,
    errorRequests: null,
    errorSend: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch withdraw requests
      .addCase(getWithdrawRequests.pending, (state) => {
        state.loadingRequests = true;
        state.errorRequests = null;
      })
      .addCase(getWithdrawRequests.fulfilled, (state, action) => {
        state.loadingRequests = false;
        state.withdrawRequests = action.payload;
      })
      .addCase(getWithdrawRequests.rejected, (state, action) => {
        state.loadingRequests = false;
        state.errorRequests = action.error.message;
      })
      // Send withdraw request
      .addCase(sendWithdrawRequest.pending, (state) => {
        state.loadingSend = true;
        state.success = null;
        state.errorSend = null;
      })
      .addCase(sendWithdrawRequest.fulfilled, (state, action) => {
        state.loadingSend = false;
        state.success = action.payload;
      })
      .addCase(sendWithdrawRequest.rejected, (state, action) => {
        state.loadingSend = false;
        state.success = null;
        state.errorSend = action.payload;
      });
  },
});

export default withdrawSlice.reducer;
